
{
  "familyId": "TAA-ONT-BETREKKELIJK",
  "questions": [
    {
      "id": "TAA-ONT-BETREKKELIJK-001",
      "familyId": "TAA-ONT-BETREKKELIJK",
      "module": "Taalbegrip",
      "tier": 15,
      "levelCode": "E8",
      "group": 8,
      "skill": "zinsontleding",
      "subSkill": "ontl_betrekkelijk",
      "questionType": "multiple_choice",
      "question": "Lees: 'Het meisje van de buren, dat altijd zingt in de tuin, is mijn nieuwe vriendin.' Welk woord is het betrekkelijk voornaamwoord?",
      "options": ["dat", "die", "wat", "van"],
      "correctAnswer": 0,
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Die of dat? Zeg je 'de' of 'het'?", "content": "Truc: zeg 'de ...' of 'het ...' voor het woord. Bij een DE-woord gebruik je DIE. Bij een HET-woord (enkelvoud) gebruik je DAT. Bij meervoud altijd DIE. Hier: 'HET meisje' → dus 'dat'.", "icon": "lightbulb"}}],
      "conceptId": "betrekkelijk_in_complex",
      "variantIndex": 1,
      "citoDifficulty": 0.50,
      "citoDiscrimination": 0.77,
      "feedback": {
        "explanationText": "'Dat' verwijst terug naar 'het meisje' (het-woord enkelvoud) en leidt de bijzin 'dat altijd zingt in de tuin' in. 'Die' zou bij een de-woord of meervoud passen. 'Wat' gebruik je alleen na 'iets/alles/het beste'. 'Van' is een voorzetsel, geen voornaamwoord.",
        "solutionSteps": [
          "Zoek de bijzin tussen de komma's",
          "Welk woord begint die bijzin? → 'dat'",
          "Check: 'dat' verwijst naar 'het meisje' (het-woord)"
        ],
        "distractorExplanations": {
          "0": "Goed! 'Dat' is het betrekkelijk voornaamwoord — verwijst naar 'het meisje' (het-woord enkelvoud).",
          "1": "'Die' is ook een betrekkelijk voornaamwoord, maar hoort bij een de-woord of meervoud. 'Het meisje' is een HET-woord enkelvoud → dus 'dat', niet 'die'.",
          "2": "'Wat' is ook een betrekkelijk voornaamwoord, maar gebruik je alleen na 'iets/alles/het beste/dat wat' — niet na een gewoon zelfstandig naamwoord zoals 'het meisje'.",
          "3": "'Van' is een voorzetsel ('van de buren'), geen betrekkelijk voornaamwoord. Betrekkelijke voornaamwoorden zijn die/dat/wie/wat."
        }
      },
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "taa.betrekkelijk-die-dat-de-woord", "label": "Kiest 'die' bij het-woord enkelvoud i.p.v. 'dat'", "optionIndex": 1 },
          { "id": "taa.betrekkelijk-wat-verkeerd-gebruikt", "label": "Gebruikt 'wat' na gewoon zelfstandig naamwoord", "optionIndex": 2 },
          { "id": "taa.betrekkelijk-voorzetsel-van-verward", "label": "Verwart voorzetsel 'van' met betrekkelijk voornaamwoord", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "TAA-ONT-BETREKKELIJK-002",
      "familyId": "TAA-ONT-BETREKKELIJK",
      "module": "Taalbegrip",
      "tier": 15,
      "levelCode": "E8",
      "group": 8,
      "skill": "zinsontleding",
      "subSkill": "ontl_betrekkelijk",
      "questionType": "multiple_choice",
      "question": "In welke zin staat een betrekkelijke bijzin (NIET een gewone bijzin met 'omdat' of 'als')?",
      "options": [
        "De fiets die ik gisteren kocht, is al kapot.",
        "Ik koop een fiets omdat de oude kapot is.",
        "Als de fiets kapot is, koop ik een nieuwe.",
        "Ik koop een fiets en hij is rood."
      ],
      "correctAnswer": 0,
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Betrekkelijke vs andere bijzinnen", "content": "Een betrekkelijke bijzin begint met die/dat/wie/wat en geeft extra info over een woord. Bijzinnen met omdat/als/terwijl zijn GEEN betrekkelijke bijzinnen.", "icon": "lightbulb"}}],
      "conceptId": "betrekkelijk_vs_andere",
      "variantIndex": 2,
      "citoDifficulty": 0.48,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "'Die ik gisteren kocht' is een betrekkelijke bijzin — 'die' verwijst terug naar 'de fiets' en geeft extra informatie over die fiets. De andere zinnen bevatten geen betrekkelijke bijzin: 'omdat' geeft reden, 'als' voorwaarde, 'en' is nevenschikkend.",
        "solutionSteps": [
          "Zoek in elke zin naar die/dat/wie/wat",
          "Bij 'de fiets DIE...' → 'die' verwijst naar 'de fiets'",
          "De andere voegwoorden (omdat/als/en) leiden andere soort zinnen in"
        ],
        "distractorExplanations": {
          "0": "Goed! 'Die ik gisteren kocht' is een betrekkelijke bijzin — extra info over de fiets.",
          "1": "Dit is een reden-bijzin ('omdat...'), geen betrekkelijke bijzin. Betrekkelijke bijzinnen beginnen met die/dat/wie/wat.",
          "2": "Dit is een voorwaarde-bijzin ('als...'), geen betrekkelijke bijzin.",
          "3": "'En' is nevenschikkend — verbindt twee hoofdzinnen. Geen bijzin."
        }
      },
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "taa.betrekkelijk-onderschikkend-verward", "label": "Verwart 'omdat'-bijzin met betrekkelijke bijzin", "optionIndex": 1 },
          { "id": "taa.betrekkelijk-onderschikkend-verward", "label": "Verwart 'als'-bijzin met betrekkelijke bijzin", "optionIndex": 2 },
          { "id": "taa.betrekkelijk-nevenschikkend-verward", "label": "Verwart nevenschikkend met betrekkelijke bijzin", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "TAA-ONT-BETREKKELIJK-003",
      "familyId": "TAA-ONT-BETREKKELIJK",
      "module": "Taalbegrip",
      "tier": 15,
      "levelCode": "E8",
      "group": 8,
      "skill": "zinsontleding",
      "subSkill": "ontl_betrekkelijk",
      "questionType": "multiple_choice",
      "question": "Welke zin is GRAMMATICAAL CORRECT?",
      "options": [
        "De boeken die ik las, waren spannend.",
        "De boeken dat ik las, waren spannend.",
        "Het boek die ik las, was spannend.",
        "De man dat naast me zit, is mijn vader."
      ],
      "correctAnswer": 0,
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Die/dat in betrekkelijke bijzinnen", "content": "Regel: het-woord enkelvoud → 'dat'. De-woord OF meervoud → 'die'. 'De boeken' is meervoud → 'die'.", "icon": "lightbulb"}}],
      "conceptId": "betrekkelijk_die_dat_evalueren",
      "variantIndex": 3,
      "citoDifficulty": 0.50,
      "citoDiscrimination": 0.78,
      "feedback": {
        "explanationText": "'De boeken' is meervoud → 'die' is correct. 'De boeken die ik las' klopt. De andere zinnen gebruiken 'dat' bij meervoud of bij een de-woord, wat fout is. Of 'die' bij een het-woord enkelvoud, ook fout.",
        "solutionSteps": [
          "De boeken (meervoud) → die ✓",
          "Het boek (het-woord enkelvoud) → dat ✓",
          "De man (de-woord) → die ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! 'De boeken' is meervoud → 'die' is correct.",
          "1": "'De boeken' is meervoud → moet 'die' zijn, niet 'dat'.",
          "2": "'Het boek' is het-woord enkelvoud → moet 'dat' zijn, niet 'die'.",
          "3": "'De man' is een de-woord → moet 'die' zijn, niet 'dat'."
        }
      },
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "taa.betrekkelijk-die-dat-meervoud", "label": "Gebruikt 'dat' bij meervoud i.p.v. 'die'", "optionIndex": 1 },
          { "id": "taa.betrekkelijk-die-dat-altijd-dat", "label": "Gebruikt 'die' bij het-woord enkelvoud", "optionIndex": 2 },
          { "id": "taa.betrekkelijk-die-dat-de-woord", "label": "Gebruikt 'dat' bij de-woord", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "TAA-ONT-BETREKKELIJK-004",
      "familyId": "TAA-ONT-BETREKKELIJK",
      "module": "Taalbegrip",
      "tier": 15,
      "levelCode": "E8",
      "group": 8,
      "skill": "zinsontleding",
      "subSkill": "ontl_betrekkelijk",
      "questionType": "multiple_choice",
      "question": "Wat is de betrekkelijke bijzin in: 'De leraar voor wie ik veel respect heb, geeft Nederlands.'?",
      "options": ["voor wie ik veel respect heb", "De leraar", "geeft Nederlands", "ik veel respect heb"],
      "correctAnswer": 0,
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Betrekkelijke bijzin met voorzetsel", "content": "Een betrekkelijke bijzin met voorzetsel begint bij het voorzetsel + voornaamwoord ('voor wie'). Neem het voorzetsel altijd mee — het hoort bij de bijzin.", "icon": "lightbulb"}}],
      "conceptId": "betrekkelijk_bijzin_voorzetsel",
      "variantIndex": 4,
      "citoDifficulty": 0.52,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "'Wie' is het betrekkelijk voornaamwoord (gebruikt na voorzetsel) en verwijst naar 'de leraar'. De volledige bijzin begint bij het voorzetsel 'voor' en eindigt vóór de komma: 'voor wie ik veel respect heb'.",
        "solutionSteps": [
          "Zoek het betrekkelijk voornaamwoord: 'wie'",
          "Kijk wat ervoor staat: 'voor' (voorzetsel)",
          "Bijzin = 'voor wie ik veel respect heb'",
          "Neem altijd het voorzetsel mee"
        ],
        "distractorExplanations": {
          "0": "Goed! 'Voor wie ik veel respect heb' is de hele betrekkelijke bijzin, inclusief voorzetsel.",
          "1": "'De leraar' is het onderwerp van de hoofdzin, geen bijzin.",
          "2": "'Geeft Nederlands' is het gezegde van de hoofdzin.",
          "3": "Je liet het voorzetsel 'voor' weg. Het voorzetsel hoort bij de bijzin."
        }
      },
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "taa.betrekkelijk-hoofdzin-als-bijzin", "label": "Kiest het onderwerp van de hoofdzin als bijzin", "optionIndex": 1 },
          { "id": "taa.betrekkelijk-gezegde-als-bijzin", "label": "Kiest het gezegde van de hoofdzin als bijzin", "optionIndex": 2 },
          { "id": "taa.betrekkelijk-voorzetsel-weggelaten", "label": "Laat het voorzetsel weg bij de betrekkelijke bijzin", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "TAA-ONT-BETREKKELIJK-005",
      "familyId": "TAA-ONT-BETREKKELIJK",
      "module": "Taalbegrip",
      "tier": 15,
      "levelCode": "E8",
      "group": 8,
      "skill": "zinsontleding",
      "subSkill": "ontl_betrekkelijk",
      "questionType": "fill_in",
      "question": "Vul het correcte betrekkelijk voornaamwoord in. 'De kinderen ___ in het zwembad spelen, hebben veel lol; het kleine meisje ___ aan de kant zit, kijkt jaloers toe.' Typ beide woorden gescheiden door een komma.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["die, dat", "die,dat"],
        "caseSensitive": false,
        "placeholder": "die/dat, die/dat"
      },
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Die of dat — afhankelijk per geval", "content": "Eerste plek: 'de kinderen' (meervoud) → 'die'. Tweede plek: 'het meisje' (het-woord enkelvoud) → 'dat'.", "icon": "lightbulb"}}],
      "conceptId": "betrekkelijk_die_dat_dubbel",
      "variantIndex": 5,
      "citoDifficulty": 0.55,
      "citoDiscrimination": 0.78,
      "feedback": {
        "explanationText": "Plek 1: 'de kinderen' is meervoud → 'die'. Plek 2: 'het meisje' is het-woord enkelvoud → 'dat'. Antwoord: 'die, dat'. Let op: je moet beide gevallen apart beoordelen — meervoud volgt 'die' (ook al is het zelfstandig naamwoord een het-woord in enkelvoud).",
        "solutionSteps": [
          "Plek 1: 'de kinderen' = meervoud → die",
          "Plek 2: 'het meisje' = het-woord enkelvoud → dat",
          "Antwoord: die, dat"
        ]
      },
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "taa.betrekkelijk-die-dat-meervoud", "label": "Gebruikt 'dat' bij meervoud (eerste plek)" },
          { "id": "taa.betrekkelijk-die-dat-de-woord", "label": "Gebruikt 'die' bij het-woord enkelvoud (tweede plek)" },
          { "id": "taa.betrekkelijk-die-dat-altijd-dat", "label": "Vult overal 'dat' in zonder onderscheid" }
        ]
      }
    },
    {
      "id": "TAA-ONT-BETREKKELIJK-006",
      "familyId": "TAA-ONT-BETREKKELIJK",
      "module": "Taalbegrip",
      "tier": 15,
      "levelCode": "E8",
      "group": 8,
      "skill": "zinsontleding",
      "subSkill": "ontl_betrekkelijk",
      "questionType": "true_false_series",
      "question": "Beoordeel elke uitspraak over deze zin: 'De schilderijen die in het museum hangen, en het beeld dat in de tuin staat, zijn allemaal van dezelfde kunstenaar.'",
      "data": {
        "statements": [
          { "text": "De zin bevat twee betrekkelijke bijzinnen.", "isTrue": true, "explanation": "Correct. 'Die in het museum hangen' (over de schilderijen) en 'dat in de tuin staat' (over het beeld) zijn beide betrekkelijke bijzinnen." },
          { "text": "'Die' verwijst hier naar 'het museum'.", "isTrue": false, "explanation": "Fout. 'Die' verwijst naar 'de schilderijen' (meervoud → die). 'Het museum' is alleen een locatie." },
          { "text": "'Dat' is correct gebruikt, want 'het beeld' is een het-woord enkelvoud.", "isTrue": true, "explanation": "Correct. Het-woord enkelvoud → 'dat'." },
          { "text": "Als je 'het beeld' zou vervangen door 'de standbeelden', moet 'dat' veranderen in 'die'.", "isTrue": true, "explanation": "Correct. Meervoud (de standbeelden) → 'die'. De regel is: het-woord enkelvoud = dat, alles anders = die." },
          { "text": "Het woord 'en' is in deze zin een betrekkelijk voornaamwoord.", "isTrue": false, "explanation": "Fout. 'En' is een nevenschikkend voegwoord — het verbindt twee delen. Betrekkelijke voornaamwoorden zijn alleen die/dat/wie/wat." }
        ]
      },
      "correctAnswer": "true,false,true,true,false",
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Analyse van betrekkelijke bijzinnen", "content": "Een betrekkelijk voornaamwoord verwijst altijd terug naar het kernwoord (het zelfstandig naamwoord) er vlak vóór. 'Die' bij meervoud of de-woord, 'dat' bij het-woord enkelvoud.", "icon": "lightbulb"}}],
      "conceptId": "betrekkelijk_analyse_serie",
      "variantIndex": 6,
      "citoDifficulty": 0.58,
      "citoDiscrimination": 0.79,
      "feedback": {
        "explanationText": "Analyse: 'die' verwijst naar 'de schilderijen' (meervoud), 'dat' naar 'het beeld' (het-woord enkelvoud). Beide zijn correct gebruikt. Bij wijziging naar meervoud zou 'dat' → 'die' worden. 'En' is een voegwoord, geen voornaamwoord.",
        "solutionSteps": [
          "Identificeer beide betrekkelijke bijzinnen",
          "Check naar welk woord het voornaamwoord verwijst",
          "Pas regel toe: meervoud/de = die, het-enk = dat"
        ]
      },
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "taa.betrekkelijk-hoofdzin-als-bijzin", "label": "Verwart antecedent met verkeerde zelfstandig naamwoord" },
          { "id": "taa.betrekkelijk-die-dat-meervoud", "label": "Past meervoudsregel niet toe" },
          { "id": "taa.betrekkelijk-nevenschikkend-verward", "label": "Beschouwt voegwoord 'en' als voornaamwoord" }
        ]
      }
    }
  ]
}
